module.exports = __webpack_public_path__ + "static/media/login-banner.5728bb83.png";